<template>
    <div class="index-disrupter"
        v-if="showDisrupter()">
        <div class="container">
            <div class="index-disrupter-inner">

                <!--<h5>
            	Moin Moin!
        		</h5>
            <p>
                Es erreicht uns eine Vielzahl an Nachfragen zu kurzfristigen Verfügbarkeiten, den geltenden Hygiene- und Sicherheitsstandards sowie der Teststrategie. Es kommt daher zeitweise zu längeren Wartezeiten. Wir bitten um Verständnis, dass wir Sie zu diesem Zeitpunkt um Ihre Mithilfe bitten:
            </p>

            <p>
                Informieren Sie sich unter <a href="//www.ostseefjordschlei.de"
                    target="_blank">www.ostseefjordschlei.de</a> über die gültigen Verordnungen sowie die Teststrategie. Die für Sie wichtigsten Informationen lassen wir Ihnen rechtzeitig vor Anreise per E-Mail zukommen. Verfügbare Ferienunterkünfte finden Sie über "Suchen & Buchen" auf unserer Website.
            </p>

            <p>
                Für alle weiteren Fragen wenden Sie sich bitte vorübergehend ausschließlich per E-Mail an <a href="mailto:urlaub@ferienhaus-agentur.de"
                    target="_blank">urlaub@ferienhaus-agentur.de</a>.
            </p>
            <p>
                Wir bedanken uns herzlich für Ihr Verständnis und Ihre Geduld. Wir melden uns schnellstmöglich bei Ihnen!
            </p>
            <p>
                #bisbaldimoro
            </p>
            <p>
                <a @click="hideDistrupter()"
                    class="btn search-btn">Schließen</a>
            </p>-->

                <h5>
           Buchen Sie JETZT Ihren Weihnachts-/Silvesterurlaub im OstseeResort Olpenitz!
  </h5>
                <ul>
                    <li>ab 3 Übernachtungen</li>
                    <li>bestellen Sie Ihren Weihnachtsbaum inkl. Lichterkette (gegen Gebühr) gleich dazu</li>
                </ul>
                <h5>
            inklusive Winter-Vorteil:
  </h5>
                <ul class="mb-0">
                    <li>kostenfreie Stornierungsmöglichkeit bis 7 Tage vor Anreise (gültig für alle Neubuchungen mit Aufenthalt bis 31.03.2022)</li>
                </ul>
                <p class="button-text">
                    <a @click="hideDistrupter()"
                        class="btn search-btn closebtn">SCHLIEßEN</a>
                </p>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
    	voVueComponent: 'index-disrupter',

    	data() {
    		return {
    			disrupter: true,
    		}
    	},
    	computed: {

    	},

    	methods: {
    		hideDistrupter() {
    				var d = new Date();
    				d.setTime(d.getTime() + (3 * 24 * 60 * 60 * 1000)); //3 days
    				var expires = "expires=" + d.toUTCString();
    				document.cookie = "disrupter=true" + ";" + expires + ";path=/";
    				this.disrupter = false;
    			},

    			showDisrupter() {
    				if (!this.disrupter) {
    					return false;
    				}
    				var name = "disrupter=";
    				var ca = document.cookie.split(';');
    				for (var i = 0; i < ca.length; i++) {
    					var c = ca[i];
    					while (c.charAt(0) == ' ') {
    						c = c.substring(1);
    					}
    					if (c.indexOf(name) == 0) {
    						return false;
    					}
    				}
    				return true;
    			}

    	}
    }
</script>